import { Icon, Text } from '@lightspeed/design-system-react'
import React, { FunctionComponent } from 'react'
import { useCustomerPaymentTypeMessage } from './useCustomerPaymentTypeMessage'

export interface CustomerPaymentTypeMessageProps {
  amountTendered: string | number
}

export const CustomerPaymentTypeMessage: FunctionComponent<CustomerPaymentTypeMessageProps> = ({
  amountTendered,
}) => {
  const userPaymentTypeMessage = useCustomerPaymentTypeMessage(amountTendered)

  return (
    userPaymentTypeMessage && (
      <Text type="supplementary" color="supplementary" className="vd-mt2">
        <Icon icon="fa-info-circle" className="vd-mr1" />
        {userPaymentTypeMessage}
      </Text>
    )
  )
}
